import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AuthProvider from './store/authProvider';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    {/* <FavcontextProvider> */}
    <React.StrictMode>
      {/* <ProSidebarProvider> */}
      <App />
      {/* </ProSidebarProvider> */}
    </React.StrictMode>
    {/* </FavcontextProvider> */}
  </AuthProvider>,

);